export const handleScheduleAvailability = (schedule) => {
    const now = new Date();
    const day = now.getDay(); 
    const dayIndex = day === 0 ? 6 : day - 1;

    if (schedule[dayIndex]?.status === false || day === 0) {
      return false;
    } else {
      const openTime = schedule[dayIndex].open; 
      const [openHours, openMinutes, openSeconds] = openTime.split(':').map(Number);
      const openInSeconds = openHours * 3600 + openMinutes * 60 + openSeconds;
      const closeTime = schedule[dayIndex].close; 
      const [closeHours, closeMinutes, closeSeconds] = closeTime.split(':').map(Number);
      const closeInSeconds = closeHours * 3600 + closeMinutes * 60 + closeSeconds;
      const nowInSeconds = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
    
      return nowInSeconds >= openInSeconds && nowInSeconds <= closeInSeconds;
    }
  };